export default "__VITE_ASSET__KVKrZKXm__"